import { Fetch } from "@seneca/client-library"
import AuthenticationServiceClient from "@seneca/authentication-service-client/dist/web";

import { getConfig } from "../../config/hooks/useGetConfig";

type AuthenticationServiceConfig = {
  protocol: string;
  host: string;
};

const browserFetch = fetch.bind(globalThis) as unknown as Fetch;

let client: AuthenticationServiceClient;

export default function getAuthenticationServiceClient() {
  if (!client) {
    const config = getConfig() as unknown as {
      services?: { authenticationService?: AuthenticationServiceConfig };
    };
    const serviceConfig = config.services?.authenticationService;

    if (!serviceConfig) throw new Error("Missing services.authenticationService config");

    client = new AuthenticationServiceClient(browserFetch, {
      protocol: serviceConfig.protocol,
      host: serviceConfig.host
    });
  }

  return client;
}
